import React from "react";
import {
  CardStyleInterpolators,
  createStackNavigator,
} from "@react-navigation/stack";
import { GlobalState } from "@redux";
import { useSelector } from "react-redux";
import { Header } from "@atomic";
import { POSNavigation } from "@modules";
import { BalanceNavigation } from "@modules/balance";
import { ProfileNavigation } from "@modules/profile";
import {
  ArticleDetail,
  HomeScreen,
  OfferDetailScreen,
  OrderCheckoutScreen,
} from "../screens";
import { HomeScreens } from "./HomeScreens";

export type HomeStackParamList = {
  [HomeScreens.HOME_SCREEN]: undefined;
  [HomeScreens.BALANCE_SCREEN]: undefined;
  [HomeScreens.POINT_OF_SALE_STACK]: undefined;
  [HomeScreens.PROFILE_STACK]: undefined;
  [HomeScreens.ARTICLE_SCREEN]: undefined;
  [HomeScreens.OFFER_DETAIL_SCREEN]: { offerId: string; holdingId?: string };
  [HomeScreens.ORDER_CHECKOUT_SCREEN]: { offerId: string; holdingId?: string };
  [HomeScreens.IDPCallback]: undefined;
};

const Stack = createStackNavigator<HomeStackParamList>();

export const HomeNavigation = () => {
  const isUserLoggedIn = useSelector(
    (state: GlobalState) => state.auth?.isLogin
  );

  return (
    <Stack.Navigator
      screenOptions={({ navigation, route }) => ({
        header: () => <Header navigation={navigation} route={route} />,
      })}
    >
      <Stack.Screen
        name={HomeScreens.HOME_SCREEN}
        key="homeScreen"
        component={HomeScreen}
      />
      {isUserLoggedIn && (
        <>
          <Stack.Screen
            name={HomeScreens.BALANCE_SCREEN}
            key="balanceScreen"
            component={BalanceNavigation}
          />
          <Stack.Screen
            name={HomeScreens.POINT_OF_SALE_STACK}
            key="pointOfSaleStack"
            component={POSNavigation}
          />
          <Stack.Screen
            name={HomeScreens.PROFILE_STACK}
            key="profileStack"
            component={ProfileNavigation}
          />
          <Stack.Screen
            name={HomeScreens.ARTICLE_SCREEN}
            key="articleScreen"
            component={ArticleDetail}
          />
          <Stack.Screen
            name={HomeScreens.OFFER_DETAIL_SCREEN}
            key="offerDetailScreen"
            component={OfferDetailScreen}
            // No transform on the card: a transformed card is a containing block
            // for `position: fixed`, which traps the embedded MFE's mobile
            // filter bottom-sheet. forNoAnimation emits an empty cardStyle.
            options={{
              cardStyleInterpolator: CardStyleInterpolators.forNoAnimation,
            }}
          />
          <Stack.Screen
            name={HomeScreens.ORDER_CHECKOUT_SCREEN}
            key="orderCheckoutScreen"
            component={OrderCheckoutScreen}
            options={{
              cardStyleInterpolator: CardStyleInterpolators.forNoAnimation,
            }}
          />
        </>
      )}
    </Stack.Navigator>
  );
};
